/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceStatusResource } from './';
import {
    ComplianceStatusResourceFromJSON,
    ComplianceStatusResourceFromJSONTyped,
    ComplianceStatusResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerComplianceResource
 */
export interface FreelancerComplianceResource {
    /**
     * 
     * @type {ComplianceStatusResource}
     * @memberof FreelancerComplianceResource
     */
    legalInformation: ComplianceStatusResource;
    /**
     * 
     * @type {ComplianceStatusResource}
     * @memberof FreelancerComplianceResource
     */
    internalCompliance: ComplianceStatusResource;
    /**
     * 
     * @type {ComplianceStatusResource}
     * @memberof FreelancerComplianceResource
     */
    externalCompliance: ComplianceStatusResource;
}

/**
 * Check if a given object implements the FreelancerComplianceResource interface.
 */
export function instanceOfFreelancerComplianceResource(value: object): value is FreelancerComplianceResource {
    if (!('legalInformation' in value) || value['legalInformation'] === undefined) return false;
    if (!('internalCompliance' in value) || value['internalCompliance'] === undefined) return false;
    if (!('externalCompliance' in value) || value['externalCompliance'] === undefined) return false;
    return true;
}

export function FreelancerComplianceResourceFromJSON(json: any): FreelancerComplianceResource {
    return FreelancerComplianceResourceFromJSONTyped(json, false);
}

export function FreelancerComplianceResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerComplianceResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalInformation': ComplianceStatusResourceFromJSON(json['legalInformation']),
        'internalCompliance': ComplianceStatusResourceFromJSON(json['internalCompliance']),
        'externalCompliance': ComplianceStatusResourceFromJSON(json['externalCompliance']),
    };
}

export function FreelancerComplianceResourceToJSON(value?: FreelancerComplianceResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalInformation': ComplianceStatusResourceToJSON(value['legalInformation']),
        'internalCompliance': ComplianceStatusResourceToJSON(value['internalCompliance']),
        'externalCompliance': ComplianceStatusResourceToJSON(value['externalCompliance']),
    };
}

